// services/collections.ts
import {
  apiClient,
  ApiError,
  ApiResponse,
  PaginatedApiResponse,
} from "@/lib/apiClient";
import { Product } from "@/types/models/product";

export const getProduct = async ({
  id,
}: {
  id: string;
}): Promise<ApiResponse<Product>> => {
  try {
    const data: ApiResponse<ApiResponse<Product>> = await apiClient.get(
      `/api/v1/admin/:storeId/products/${id}`,
    );
    return {
      data: data.data.data,
      status: data.status,
      message: data.message,
      success: data.success,
      valid: data.valid,
    };
  } catch (error: unknown) {
    if (error instanceof ApiError) {
      throw error;
    }
    throw new ApiError(500, "UNKNOWN_ERROR", "An unexpected error occurred");
  }
};
export const getProducts = async ({
  page,
  pageSize,
  filters,
}: {
  page: number;
  pageSize: number;
  filters?: any;
}): Promise<PaginatedApiResponse<Product[]>> => {
  try {
    const queryParams: Record<string, string> = {
      page: page.toString(),
      page_size: pageSize.toString(),
    };

    // Add filters to query params if provided
    if (filters) {
      if (filters.title) {
        queryParams.title = filters.title;
      }
      if (filters.status) {
        queryParams.status = filters.status;
      }
      if (filters.category) {
        queryParams.category = filters.category;
      }
      if (filters.priceMin !== undefined) {
        queryParams.price_min = filters.priceMin.toString();
      }
      if (filters.priceMax !== undefined) {
        queryParams.price_max = filters.priceMax.toString();
      }
    }

    console.log("getProducts calling API with URL:", "/api/v1/admin/:storeId/products", "and params:", queryParams);
    console.log("getProducts calling API with URL:", "/api/v1/admin/:storeId/products", "and params:", queryParams);
    const data: PaginatedApiResponse<Product[]> = await apiClient.getPaginated(
      "/api/v1/admin/:storeId/products",
      queryParams,
    );
    return data;
  } catch (error: unknown) {
    if (error instanceof ApiError) {
      throw error;
    }
    throw new ApiError(500, "UNKNOWN_ERROR", "An unexpected error occurred");
  }
};
export const postProducts = async ({
  data,
}: {
  data: Product;
}): Promise<ApiResponse<Product>> => {
  try {
    let response: ApiResponse<Product>;
    if (data.id) {
      response = await apiClient.put(
        `/api/v1/admin/:storeId/products/${data.id}`,
        data,
      );
    } else {
      response = await apiClient.post(`/api/v1/admin/:storeId/products`, data);
    }

    return {
      data: response.data,
      status: response.status,
      message: response.message,
      success: response.success,
      valid: response.valid,
    };
  } catch (error: unknown) {
    if (error instanceof ApiError) {
      throw error;
    }
    throw new ApiError(500, "UNKNOWN_ERROR", "An unexpected error occurred");
  }
};
export const deleteProducts = async ({
  id,
}: {
  id: string;
}): Promise<ApiResponse<Product>> => {
  try {
    const response: ApiResponse<Product> = await apiClient.delete(
      `/api/v1/admin/:storeId/products/${id}`,
    );
    return {
      data: response.data,
      status: response.status,
      message: response.message,
      success: response.success,
      valid: response.valid,
    };
  } catch (error: unknown) {
    if (error instanceof ApiError) {
      throw error;
    }
    throw new ApiError(500, "UNKNOWN_ERROR", "An unexpected error occurred");
  }
};
export const updateProductStatusAction = async ({
  id,
  status,
}: {
  id: string;
  status: string;
}): Promise<ApiResponse<null>> => {
  try {
    const response: ApiResponse<null> = await apiClient.patch(
      `/api/v1/admin/:storeId/products/${id}/status`,
      { status },
    );
    return {
      data: null,
      status: response.status,
      message: response.message,
      success: response.success,
      valid: response.valid,
    };
  } catch (error: unknown) {
    if (error instanceof ApiError) {
      throw error;
    }
    throw new ApiError(500, "UNKNOWN_ERROR", "An unexpected error occurred");
  }
};

export const searchProducts = async ({
  query,
  page = 1,
  pageSize = 20,
  status,
}: {
  query: string;
  page?: number;
  pageSize?: number;
  status?: string;
}): Promise<PaginatedApiResponse<Product[]>> => {
  try {
    const queryParams: Record<string, string> = {
      q: query,
      page: page.toString(),
      page_size: pageSize.toString(),
    };
    
    // Add status filter if provided
    if (status) {
      queryParams.status = status;
    }
    
    const data: PaginatedApiResponse<Product[]> = await apiClient.getPaginated(
      "/api/v1/admin/:storeId/products/search",
      queryParams,
    );
    return data;
  } catch (error: unknown) {
    if (error instanceof ApiError) {
      throw error;
    }
    throw new ApiError(500, "UNKNOWN_ERROR", "An unexpected error occurred");
  }
};
